function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import React from "react";

var _ref =
/*#__PURE__*/
React.createElement("path", {
  fillRule: "evenodd",
  clipRule: "evenodd",
  d: "M14.5 29C22.508 29 29 22.508 29 14.5S22.508 0 14.5 0 0 6.492 0 14.5 6.492 29 14.5 29zm8.86-18.094a1.25 1.25 0 10-1.72-1.812l-9.118 8.66-3.638-3.638a1.25 1.25 0 00-1.768 1.768l5.362 5.361L23.36 10.906z",
  fill: "#00BC75"
});

var SvgReportingKpiSuccess = function SvgReportingKpiSuccess(props) {
  return React.createElement("svg", _extends({
    width: 29,
    height: 29,
    fill: "none"
  }, props), _ref);
};

export default SvgReportingKpiSuccess;